import { NotFound } from 'modules/NotFound'
import { useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { Reschedule as Index, RescheduleNew, RescheduleSuccess as Success } from '../../../../components/Appointment'
import { SchedulingStateProvider, useRescheduleContext } from '../../../../hooks'

const New = () => (
  <SchedulingStateProvider>
    <RescheduleNew />
  </SchedulingStateProvider>
)

const Reschedule = () => {
  const { clearContext } = useRescheduleContext()

  useEffect(() => clearContext(), [])

  return (
    <Routes>
      <Route element={<Index />} path="/" />
      <Route element={<New />} path="new" />
      <Route element={<Success />} path="success" />
      <Route element={<NotFound />} path="*" />
    </Routes>
  )
}

export { Reschedule }
